<template>
    <div class="container-fluid">
        <div class="view-header my-4">
            <div class="view-header__main">
                <div class="view-header__info">
                    <h1 class="view-header__title">Configuracion de la tienda online</h1>
                </div>
                <div class="view-header__actions">
                    <button type="button" class="btn view-header__btn view-header__btn--primary" @click="updateConfig()">
                        <i class="bi bi-save"></i>
                        Guardar configuración
                    </button>
                </div>
            </div>
        </div>

        <ul class="nav product-tabs mt-3">
            <li class="nav-item"><a class="nav-link" href="#" :class="{active: activeTab==0}" @click.prevent="activeTab=0">Configuracion de Ecommerce</a></li>
            <li class="nav-item"><a class="nav-link" href="#" :class="{active: activeTab==1}" @click.prevent="activeTab=1">Diseño de Pagina</a></li>
            <li class="nav-item"><a class="nav-link" href="#" :class="{active: activeTab==2}" @click.prevent="activeTab=2">Destacados</a></li>
        </ul>

        <!-- Pestaña de configuraciones -->
        <div v-show="activeTab==0">
            <div class="row">
                <div class="col-md-4">
                    <div class="form-card mb-4">
                        <div class="form-card__header">
                            <h6 class="form-card__title"><i class="bi bi-people"></i> Opciones de usuarios</h6>
                        </div>
                        <div class="form-card__body d-flex align-items-start flex-column">
                            <label class="d-inline-flex align-items-center mb-1">
                                <input v-model="config.page_active" type="checkbox" class="mr-2">
                                Activar página de E-commerce
                            </label>
                            <label class="d-inline-flex align-items-center mb-1">
                                <input v-model="config.allow_sale_unlogged" type="checkbox" class="mr-2">
                                Permitir compras de usuarios no logueados
                            </label>
                            <label class="d-inline-flex align-items-center mb-1">
                                <input v-model="config.show_public_prices" type="checkbox" class="mr-2">
                                Permitir que los precios se vean sin estar logueado
                            </label>
                            <label class="d-inline-flex align-items-center mb-1">
                                <input v-model="config.show_stock" type="checkbox" class="mr-2">
                                Mostrar disponibilidad de stock en producto
                            </label>
                            <label class="d-inline-flex align-items-center mb-1">
                                <input v-model="config.variant_check" type="checkbox" class="mr-2">
                                Verificar productos con variantes seleccionada.
                            </label>
                            <label class="d-inline-flex align-items-center mb-1">
                                <input v-model="config.sale_without_stock" type="checkbox" class="mr-2">
                                Permitir venta de productos sin stock
                            </label>
                            <label class="d-inline-flex align-items-center mb-1">
                                <input v-model="config.show_pricelists" type="checkbox" class="mr-2">
                                Mostrar listas mayoristas y minoristas a todos los usuarios
                            </label>
                            <label class="d-inline-flex align-items-center mb-1">
                                <input v-model="config.show_mercadopago" type="checkbox" class="mr-2">
                                Usar Mercado Pago como medio de pago
                            </label>
                            <div class="form-card__field w-100" v-show="config.show_mercadopago">
                                <label class="form-card__label">Mercado Pago Token:</label>
                                <input type="text" class="form-control" v-model="config.mercadopago_app_token">
                            </div>
                            <div class="form-card__field w-100 mt-4">
                                <label class="form-card__label">Asignar lista de precios (minorista) por defecto:</label>
                                <select class="form-control" v-model="config.pricelist_retail">
                                    <option :value="0">Ninguna</option>
                                    <option v-for="price in priceLists" :key="price.id" :value="price.id">{{price.name}}</option>
                                </select>
                            </div>
                            <div class="form-card__field w-100" v-bind:class="[{'disabled': !config.show_pricelists}]">
                                <label class="form-card__label">Asignar lista de precios mayorista por defecto:</label>
                                <select class="form-control" v-model="config.pricelist_wholesale" v-bind:class="[{'disabled': !config.show_pricelists}]">
                                    <option :value="0">Ninguna</option>
                                    <option v-for="price in priceLists" :key="price.id" :value="price.id">{{price.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Filtros y metodos de pago-->
                <div class="col-md-4">
                    <div class="form-card mb-4">
                        <div class="form-card__header">
                            <h6 class="form-card__title"><i class="bi bi-funnel"></i> Filtros</h6>
                        </div>
                        <div class="form-card__body d-flex align-items-start flex-column">
                            <label class="form-card__label">Filtros en el menu lateral de la tienda:</label>
                            <label class="d-inline-flex align-items-center mb-1">
                                <input v-model="config.fillers.filters.categories" disabled type="checkbox" class="mr-2">
                                <b>Categorias</b>
                            </label>
                            <label class="d-inline-flex align-items-center mb-1">
                                <input v-model="config.fillers.filters.brands" type="checkbox" class="mr-2">
                                Marcas
                            </label>
                            <label class="d-inline-flex align-items-center mb-1">
                                <input v-model="config.fillers.filters.groups" type="checkbox" class="mr-2">
                                Grupos de atributos:
                            </label>
                            <hr class="w-100">
                            <div class="col-12" v-if="config.fillers.filters.groups">
                                <div class="data-table">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Grupo</th>
                                                <th>Estilo</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(group, index) in attGroups" :key="index">
                                                <td>{{group.name}}</td>
                                                <td>
                                                    <span v-if="group.class=='color'">Color</span>
                                                    <span v-if="group.class=='tag'">Etiqueta</span>
                                                    <span v-if="group.class=='list'">Lista</span>
                                                </td>
                                                <td>
                                                    <input type="checkbox"
                                                        v-model="config.activeGroups"
                                                        v-bind:value="group.id"/>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="form-card__header">
                            <h6 class="form-card__title"><i class="bi bi-credit-card"></i> Métodos de pago</h6>
                        </div>
                    </div>
                </div>

                <!-- Datos de contacto -->
                <div class="col-md-4">
                    <div class="form-card mb-4">
                        <div class="form-card__header">
                            <h6 class="form-card__title"><i class="bi bi-telephone"></i> Datos de contacto</h6>
                        </div>
                        <div class="form-card__body">
                            <div class="form-card__field">
                                <label class="form-card__label">Email de contacto:</label>
                                <input type="email" class="form-control" v-model="config.contact.email" placeholder="contacto@email.com">
                            </div>
                            <div class="form-card__field">
                                <label class="form-card__label">Telefonos de contacto</label>
                                <div class="row">
                                    <div class="col-md-6">
                                        <input type="text" class="form-control" placeholder="Telefono #1" v-model="config.contact.phone1">
                                    </div>
                                    <div class="col-md-6">
                                        <input type="text" class="form-control" placeholder="Telefono #2" v-model="config.contact.phone2">
                                    </div>
                                </div>
                            </div>
                            <div class="form-card__field">
                                <label class="form-card__label">Direccion</label>
                                <input type="text" placeholder="Dirección" class="form-control" v-model="config.contact.address1">
                            </div>
                            <div class="form-card__field">
                                <label class="form-card__label">Cuidad</label>
                                <input type="text" placeholder="Localidad - Provincia - Pais" class="form-control" v-model="config.contact.address2">
                            </div>
                            <div class="form-card__field">
                                <label class="form-card__label">Horarios de contacto:</label>
                                <input type="email" class="form-control" v-model="config.contact.workhours" placeholder="00:00 lun - 00:00 dom">
                            </div>
                            <div class="form-card__field">
                                <label class="form-card__label"><i class="bi bi-facebook mr-2"></i>Facebook</label>
                                <input type="text" class="form-control" placeholder="facebook.com/web" v-model="config.networks.facebook">
                            </div>
                            <div class="form-card__field">
                                <label class="form-card__label"><i class="bi bi-twitter mr-2"></i>Twitter</label>
                                <input type="text" class="form-control" placeholder="twitter.com/web" v-model="config.networks.twitter">
                            </div>
                            <div class="form-card__field">
                                <label class="form-card__label"><i class="bi bi-instagram mr-2"></i>Instagram</label>
                                <input type="text" class="form-control" placeholder="instagram.com/web" v-model="config.networks.instagram">
                            </div>
                            <div class="form-card__field">
                                <label class="form-card__label"><i class="bi bi-whatsapp mr-2"></i>whatsapp</label>
                                <input type="text" class="form-control" placeholder="# whatsapp" v-model="config.networks.whatsapp">
                            </div>
                            <div class="form-card__field">
                                <label class="form-card__label"><i class="bi bi-telegram mr-2"></i>Telegram</label>
                                <input type="text" class="form-control" placeholder="# telegram" v-model="config.networks.telegram">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Pestaña de personalizacion de pagina -->
        <div v-show="activeTab==1">
            <div class="row">
                <div class="col-md-4">
                    <div class="form-card mb-4">
                        <div class="form-card__header">
                            <h6 class="form-card__title"><i class="bi bi-image"></i> Imágenes</h6>
                        </div>
                        <div class="form-card__body">
                            <div class="row mt-3">
                                <div class="col-md-6">
                                    <h6 class="text-center">Logo de e-commerce</h6>
                                    <vue-upload-multiple-image
                                        @upload-success="uploadImageSuccessLogo"
                                        @before-remove="beforeRemoveLogo"
                                        @edit-image="editImageLogo"
                                        dragText="260 x 80"
                                        browseText="Buscar logo"
                                        primaryText=""
                                        markIsPrimaryText=""
                                        popupText="Logo"
                                        dropText="Arrastre y suelte"
                                        :multiple="true"
                                        :maxImage="1"
                                        :showEdit="false"
                                        :data-images="logoPrev"
                                        idUpload="logoUp"
                                        idEdit="logoEd"
                                    />
                                </div>
                                <div class="col-md-6">
                                    <h6 class="text-center">FavIcon</h6>
                                    <vue-upload-multiple-image
                                        @upload-success="uploadImageSuccessIcon"
                                        @before-remove="beforeRemoveIcon"
                                        @edit-image="editImageIcon"
                                        dragText="16 x 16"
                                        browseText="Buscar icono"
                                        primaryText=""
                                        markIsPrimaryText=""
                                        popupText="Imagenes"
                                        dropText="Arrastre y suelte"
                                        :multiple="true"
                                        :maxImage="1"
                                        :showEdit="false"
                                        :data-images="iconPrev"
                                        idUpload="iconUp"
                                        idEdit="iconEd"
                                    />
                                </div>
                                <div class="col-md-6">
                                    <h6 class="text-center">Imagenes de portada</h6>
                                    <vue-upload-multiple-image
                                        @upload-success="uploadImageSuccessDash"
                                        @before-remove="beforeRemoveDash"
                                        @edit-image="editImageDash"
                                        dragText="1000 x 530"
                                        browseText="Buscar imagen"
                                        primaryText=""
                                        markIsPrimaryText=""
                                        popupText="Imagenes"
                                        dropText="Arrastre y suelte"
                                        :multiple="true"
                                        :maxImage="3"
                                        :showEdit="false"
                                        :data-images="dashPrev"
                                        idUpload="dashUp"
                                        idEdit="dashEd"
                                    />
                                </div>
                                <div class="col-md-6">
                                    <h6 class="text-center">Cabecera "Nosotros"</h6>
                                    <vue-upload-multiple-image
                                        @upload-success="uploadImageSuccessAbout"
                                        @before-remove="beforeRemoveAbout"
                                        @edit-image="editImageAbout"
                                        dragText="1500 x 500"
                                        browseText="Buscar cabecera"
                                        primaryText=""
                                        markIsPrimaryText=""
                                        popupText="Imagenes"
                                        dropText="Arrastre y suelte"
                                        :multiple="true"
                                        :maxImage="1"
                                        :showEdit="false"
                                        :data-images="aboutPrev"
                                        idUpload="aboutUp"
                                        idEdit="aboutEd"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-card mb-4">
                        <div class="form-card__header">
                            <h6 class="form-card__title"><i class="bi bi-card-text"></i> Textos</h6>
                        </div>
                        <div class="form-card__body">
                            <div class="form-card__field">
                                <h6>Titulo de la pagina:</h6>
                                <input type="text" class="form-control" v-model="config.page_title" placeholder="Titulo">
                            </div>
                            <div class="form-card__field">
                                <h6>Texto "Acerca de nosotros":</h6>
                                <textarea rows="5" v-model="config.fillers.aboutus" placeholder="Escribe aqui información sobre la actividad de tu empresa..." class="form-control"></textarea>
                            </div>
                            <div class="form-card__field">
                                <label class="d-inline-flex align-items-center mb-1">
                                    <input v-model="config.fillers.alerts.news.active" type="checkbox" class="mr-2">
                                    <b>Banner de noticias</b>
                                </label>
                                <textarea rows="3" v-model="config.fillers.alerts.news.message" class="form-control" placeholder="Escribe aqui un mensaje que se mostrara en la parte superior de la pagina..."
                                v-bind:class="[{'disabledarea': !config.fillers.alerts.news.active}]" />
                            </div>
                            <div class="form-card__field">
                                <label class="d-inline-flex align-items-center mb-1">
                                    <input v-model="config.fillers.alerts.welcome.active" type="checkbox" class="mr-2">
                                    <b>Alerta de bienvenida</b>
                                </label>
                                <textarea rows="3" v-model="config.fillers.alerts.welcome.message" class="form-control" placeholder="Escribe aqui un mensaje que se mostrara al ingresar en la pagina..."
                                v-bind:class="[{'disabledarea': !config.fillers.alerts.welcome.active}]"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-card mb-4">
                        <div class="form-card__header">
                            <h6 class="form-card__title"><i class="bi bi-palette"></i> Colores</h6>
                        </div>
                        <div class="form-card__body">
                                <!-- Vista previa: mini-tienda en vivo -->
                                <div class="store-preview">
                                    <div class="store-preview__header">
                                        <span class="store-preview__brand" :style="{ color: config.styles.colorPrimary }">MI TIENDA</span>
                                        <span class="store-preview__search">
                                            Buscar…
                                            <span class="store-preview__search-btn" :style="{ background: config.styles.colorPrimary }"><i class="bi bi-search"></i></span>
                                        </span>
                                        <i class="bi bi-cart3"></i>
                                        <i class="bi bi-person"></i>
                                    </div>
                                    <div class="store-preview__nav">
                                        <span class="store-preview__cat" :style="{ background: config.styles.colorPrimary }"><i class="bi bi-list"></i> CATEGORÍAS</span>
                                        <span class="store-preview__nav-item store-preview__nav-item--active" :style="{ color: config.styles.colorPrimary, borderColor: config.styles.colorPrimary }">TIENDA</span>
                                        <span class="store-preview__nav-item">CONTACTO</span>
                                    </div>
                                    <div class="store-preview__card">
                                        <div class="store-preview__img"><i class="bi bi-image"></i></div>
                                        <div class="store-preview__info">
                                            <span class="store-preview__name">ABANICO FLOREADO</span>
                                            <div class="store-preview__meta">
                                                <span class="store-preview__sku">SKU #9627</span>
                                                <span class="store-preview__stock"><i class="bi bi-circle-fill"></i> EN STOCK</span>
                                            </div>
                                            <div class="store-preview__price-row">
                                                <span class="store-preview__price" :style="{ color: config.styles.colorPrimary }">$1.500</span>
                                                <span class="store-preview__tag" :style="{ background: config.styles.colorAlert }">Oferta</span>
                                            </div>
                                            <div class="store-preview__actions">
                                                <button type="button" class="store-preview__btn" :style="{ background: hover.button }"
                                                    @mouseover="hover.button = config.styles.colorAccentDark"
                                                    @mouseout="hover.button = config.styles.colorPrimary"
                                                    @mousedown="hover.button = config.styles.colorAccentLight"
                                                    @mouseup="hover.button = config.styles.colorAccentDark">
                                                    <i class="bi bi-cart-plus"></i> Agregar
                                                </button>
                                                <button type="button" class="store-preview__btn store-preview__btn--outline" :style="{ color: config.styles.colorPrimary, borderColor: config.styles.colorPrimary }">
                                                    <i class="bi bi-lightning-charge"></i> Comprar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-card__field mt-3">
                                    <label class="form-card__label">Color principal de la tienda</label>
                                    <p class="form-card__hint">Botones, precios, enlaces, ítems activos y destacados. El tono al pasar el mouse se calcula solo.</p>
                                    <Colorpick :color="stprimary" v-model="stprimary" />
                                </div>
                                <div class="form-card__field">
                                    <label class="form-card__label">Color de oferta</label>
                                    <p class="form-card__hint">Etiqueta de productos en oferta</p>
                                    <Colorpick :color="stalert" v-model="stalert" />
                                </div>
                                <button type="button" class="form-card__btn w-100" @click="resetColors()">
                                    <i class="bi bi-arrow-counterclockwise"></i> Restablecer diseño
                                </button>
                            </div>
                        </div>
                </div>
            </div>
        </div>

        <!-- Pestaña de promociones -->
        <div v-show="activeTab==2">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-card mb-4">
                        <div class="form-card__header">
                            <h6 class="form-card__title"><i class="bi bi-star"></i> Lista de productos destacados</h6>
                        </div>
                        <div class="form-card__body">
                            <div class="form-card__field">
                                <typeahead
                                    :name="'featuredSearch'"
                                    :placeh="'Buscar producto...'"
                                    :clean-on="true"
                                    v-on:choosed="featuredChoosen"
                                    :externalsrc="'/api/products/searchProducts'"
                                    limit-chars="2"
                                />
                            </div>
                            <div class="data-table">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Producto</th>
                                            <th>Cod.Interno</th>
                                            <th>Cod.Barras</th>
                                            <th>Creación</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="prod in featList" :key="prod.id">
                                            <td>{{prod.name}}</td>
                                            <td>{{prod.code}}</td>
                                            <td>{{prod.barcode}}</td>
                                            <td>{{formatDate(prod.created_at)}}</td>
                                            <td>
                                                <button type="button" class="btn btn-sm btn-danger" @click="featuredRemove(prod.id)" title="Remover"><i class="bi bi-trash"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="loading" v-if="loading">Loading&#8230;</div>
        </div>
    </div>


</template>

<script>
import VueUploadMultipleImage from '../global/UploadMultipleImage.vue';
import typeahead from '../global/Typeahead.vue';
import Colorpick from '../global/Colorpicker.vue';
import moment from 'moment';

export default {
  props: [],
  components: {
      VueUploadMultipleImage,
      typeahead,
      Colorpick
  },
  data() {
    return {
      activeTab: 0,
      config :{
          page_active: 0,
          show_public_prices: 0,
          show_pricelists: 0,
          show_mercadopago: 0,
          mercadopago_app_token: null,
          show_stock:0,
          pricelist_retail:0,
          pricelist_wholesale: 0,
          allow_sale_unlogged: 0,
          variant_check:0,
          sale_without_stock:0,
          page_title:'',
          contact:{
              email:null,
              phone1:null,
              phone2:null,
              address1:null,
              address2:null,
              workhours:null,
          },
          networks:{
              facebook:null,
              twitter:null,
              instagram:null,
              whatsapp:null,
              telegram:null,
          },
          fillers:{
              aboutus:'',
              featured:[],
              filters:{
                  categories:true,
                  brands:true,
                  groups:false,
              },
              alerts:{
                  news:{
                      active:false,
                      message:''
                  },
                  welcome:{
                    active:false,
                    message:''
                  },
              }
          },
          styles:{
              colorPrimary:'#BCBCBC',
              colorSecondary:'#747474',
              colorAccent:'#747474',
              colorAccentDark:'#BCBCBC',
              colorAccentLight:'#747474',
              colorAlert:'#BCBCBC',
          },
          images:{
              logo:[],
              favIcon:[],
              imgDash:[],
              imgAbout:[],
              prevLogo:[],
              prevIcon:[],
              prevAbout:[],
              prevDash:[],
          },
          activeGroups: [],
      },
      priceLists:[],
      logoPrev:[],
      dashPrev:[],
      iconPrev:[],
      aboutPrev:[],
      attGroups:[],
      featList:[],
      loading:true,
      hover:{
          secondary:'#FFFFFF',
          alert:'#FFFFFF',
          tag:{
              border:'2px solid #eeeeee',
              background:'#FFFFFF',
              text:'#555555',
          },
          button:'#747474',
      }
    }
  },
  mounted() {
    this.loadPriceLists();
    this.loadAttGroups();
    this.loadConfigs();
  },
  computed: {
        stprimary:{
            get: function () {return this.config.styles.colorPrimary;},
            set: function (value) {
                this.config.styles.colorPrimary = value;
                // Toda la paleta de la tienda se deriva del color principal:
                // accent = principal, accent-dark/secondary = más oscuro (hover),
                // accent-light = más claro. (Misma relación que los defaults de la tienda.)
                this.config.styles.colorAccent = value;
                this.config.styles.colorAccentDark = this.shadeColor(value, -15);
                this.config.styles.colorAccentLight = this.shadeColor(value, 15);
                this.config.styles.colorSecondary = this.shadeColor(value, -15);
                this.hover.button = value;
            }
        },
        stsecondary:{
            get: function () {return this.config.styles.colorSecondary;},
            set: function (value) {this.config.styles.colorSecondary=value;}
        },
        staccent:{
            get: function () {return this.config.styles.colorAccent;},
            set: function (value) {this.config.styles.colorAccent=value;}
        },
        staccentd:{
            get: function () {return this.config.styles.colorAccentDark;},
            set: function (value) {this.config.styles.colorAccentDark=value;}
        },
        staccentl:{
            get: function () {return this.config.styles.colorAccentLight;},
            set: function (value) {this.config.styles.colorAccentLight=value;}
        },
        stalert:{
            get: function () {return this.config.styles.colorAlert;},
            set: function (value) {this.config.styles.colorAlert=value;}
        },
    },
  methods: {
    // Aclara/oscurece un color hex. percent: positivo aclara, negativo oscurece.
    shadeColor(hex, percent) {
        if (!hex || hex.charAt(0) !== '#') return hex;
        let h = hex.replace('#', '');
        if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
        const num = parseInt(h, 16);
        const amt = Math.round((percent / 100) * 255);
        const clamp = function (v) { return Math.max(0, Math.min(255, v)); };
        const r = clamp((num >> 16) + amt);
        const g = clamp(((num >> 8) & 0xff) + amt);
        const b = clamp((num & 0xff) + amt);
        return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    loadConfigs() {
        let vm = this;
        this.$http.get('/api/ecom/config/get')
          .then((response) => {
            if (response.data.success) {
                let r = response.data.data;
                vm.setConfigs(r);
            } else {
                console.log('error al cargar la configuracion de ecommerce: ' + response.data.message);
                vm.loading = false;
            }
          }).catch((error) => {
            console.log('error: '+error);
            vm.loading = false;
        })
    },
    updateConfig() {
        if(this.checkInputs() == true){
            let vm = this;
            vm.loading=true;
            this.$http.post('/api/ecom/config/set', this.config)
                .then(() => {
                    
                    window.location.reload();
                    }).catch((error) => {
                        console.log('error: '+error);
                    })
        }
    },
    setConfigs(r){
        this.config.page_active = r.page_active;
        this.config.show_public_prices = r.show_public_prices;
        this.config.show_pricelists = r.show_pricelists;
        this.config.show_stock = r.show_stock;
        this.config.show_mercadopago = r.show_mercadopago,
        this.config.mercadopago_app_token = r.mercadopago_app_token,
        this.config.pricelist_retail = (r.pricelist_retail) ? r.pricelist_retail : 0;
        this.config.pricelist_wholesale = (r.pricelist_wholesale) ? r.pricelist_wholesale : 0;
        this.config.allow_sale_unlogged = r.allow_sale_unlogged;
        this.config.page_title = r.page_title;
        this.config.variant_check = r.variant_check;
        this.config.sale_without_stock = r.sale_without_stock;

        if(r.contact!=null){
            let rcontact = JSON.parse(r.contact);
            this.config.contact.email = rcontact.email;
            this.config.contact.phone1 = rcontact.phone1;
            this.config.contact.phone2 = rcontact.phone2;
            this.config.contact.address1 = rcontact.address1;
            this.config.contact.address2 = rcontact.address2;
            this.config.contact.workhours = rcontact.workhours;
        }

        if(r.networks!=null){
            let rnetworks = JSON.parse(r.networks);
            this.config.networks.facebook = rnetworks.facebook;
            this.config.networks.twitter = rnetworks.twitter;
            this.config.networks.instagram = rnetworks.instagram;
            this.config.networks.whatsapp = rnetworks.whatsapp;
            this.config.networks.telegram = rnetworks.telegram;
        }

        if(r.fillers!=null){
            let rfillers = JSON.parse(r.fillers);
            this.config.fillers.aboutus = rfillers.aboutus;
            if(rfillers.featured!=null){
                this.config.fillers.featured = rfillers.featured;
                this.featList = r.featured_prods;
            }
            if(rfillers.filters!=null){
                this.config.fillers.filters.categories = rfillers.filters.categories;
                this.config.fillers.filters.brands = rfillers.filters.brands;
                this.config.fillers.filters.groups = rfillers.filters.groups;
                this.config.fillers.filters.attGroups = rfillers.filters.attGroups;
            }
            if(rfillers.alerts!=null){
                this.config.fillers.alerts.news.active = rfillers.alerts.news.active;
                this.config.fillers.alerts.news.message = rfillers.alerts.news.message;
                this.config.fillers.alerts.welcome.active = rfillers.alerts.welcome.active;
                this.config.fillers.alerts.welcome.message = rfillers.alerts.welcome.message;
            }
        }

        if(r.styles!=null){
            let rstyles = JSON.parse(r.styles);
            this.config.styles.colorPrimary=rstyles.colorPrimary;
            this.config.styles.colorSecondary=rstyles.colorSecondary;
            this.config.styles.colorAccent=rstyles.colorAccent;
            this.config.styles.colorAccentDark=rstyles.colorAccentDark;
            this.config.styles.colorAccentLight=rstyles.colorAccentLight;
            this.config.styles.colorAlert=rstyles.colorAlert;

            this.hover.button = rstyles.colorAccent;
        }

        if(r.images.logo.length>0){
            this.config.images.prevLogo= r.images.logo;
            this.config.images.logo = r.images.logo;
            const logoPath = String(r.images.logo);
            const modifiedLogoPath = logoPath.replace('localhost/', 'localhost/apiecom/');
            this.logoPrev.push({
                path: modifiedLogoPath,
                default: 1,
                highlight: 0,
                caption: '',
            });
        }

        if(r.images.favIcon.length>0){
            this.config.images.prevIcon = r.images.favIcon;
            this.config.images.favIcon = r.images.favIcon;
            const logoPath = String(r.images.favIcon);
            const modifiedLogoPath = logoPath.replace('localhost/', 'localhost/apiecom/');
            this.iconPrev.push({
                path: modifiedLogoPath,
                default: 1,
                highlight: 0,
                caption: '',
            });
        }

        if(r.images.imgAbout.length>0){
            this.config.images.prevAbout = r.images.imgAbout;
            this.config.images.imgAbout = r.images.imgAbout;
            const logoPath = String(r.images.imgAbout);
            const modifiedLogoPath = logoPath.replace('localhost/', 'localhost/apiecom/');
            this.aboutPrev.push({
                path: modifiedLogoPath,
                default: 1,
                highlight: 0,
                caption: '',
            });
        }

        let dashAux=[];
        this.config.images.prevDash = r.images.imgDash;
        r.images.imgDash.forEach(e => {
            this.config.images.imgDash.push(e);
            const logoPath = String(e);
            const modifiedLogoPath = logoPath.replace('localhost/', 'localhost/apiecom/');
            dashAux.push({
                path: modifiedLogoPath,
                default: 1,
                highlight: 0,
                caption: '',
            });
        });
        this.dashPrev = dashAux;
        this.loading = false;
    },
    resetColors(){
        if(confirm('¿Restablecer colores predeterminados?')===true){
            this.config.styles.colorPrimary='#BCBCBC';
            this.config.styles.colorSecondary='#747474';
            this.config.styles.colorAccent='#747474';
            this.config.styles.colorAccentDark='#BCBCBC';
            this.config.styles.colorAccentLight='#747474';
            this.config.styles.colorAlert='#BCBCBC';

            this.hover.button = this.config.styles.colorAccent;
        }
    },
    formatDate(date){
        return moment(String(date)).format('DD/MM/YYYY');
    },
    loadPriceLists(){
        let vm= this;
        this.$http.get("/api/priceslist/getPriceList")
            .then((response) => {
                if (response.status==200) {
                    vm.priceLists = response.data.data;
                } else {
                  // no-op intencional
                    
                }
            }).catch((error) => {
                console.log('error: '+error);
        })
    },
    loadAttGroups(){
        let vm= this;
        this.$http.get("/api/variants/getAttGroups")
            .then((response) => {
                if (response.status==200) {
                    vm.attGroups = response.data.data;
                    vm.attGroups.forEach(e => {
                        if(e.filter){
                            vm.config.activeGroups.push(e.id);
                        }
                    });
                } else {
                  // no-op intencional
                    
                }
            }).catch((error) => {
                console.log('error: '+error);
        })
    },
    attGroupChoosen(data) {
        var isInArray = this.config.attGroups.findIndex(function(i){ return i === data.id }) !== -1;
        if(!isInArray && this.config.fillers.filters.groups){
            this.attGroups.push(data);
            this.config.attGroups.push(data.id);
        }
    },
    attGroupRemove(id) {
        this.attGroups.splice(this.attGroups.findIndex(function(i){return i.id === id;}), 1);
        this.config.attGroups.splice(this.config.attGroups.findIndex(function(i){return i === id;}), 1);
    },
    featuredChoosen(data){
        var isInArray = this.config.fillers.featured.findIndex(function(i){ return i === data.id }) !== -1;
        if(!isInArray){
            this.featList.push(data);
            this.config.fillers.featured.push(data.id);
        }
    },
    featuredRemove(id) {
        this.featList.splice(this.featList.findIndex(function(i){return i.id === id;}), 1);
        this.config.fillers.featured.splice(this.config.fillers.featured.findIndex(function(i){return i === id;}), 1);
    },
    beforeRemoveLogo(index, done, fileList) {
        var r = confirm("¿Desea eliminar el logo?")
        if (r == true) {
            done()
            this.config.images.logo = fileList.map(x=> x.path)
        }
    },
    uploadImageSuccessLogo(formData, index, fileList) {this.config.images.logo = fileList.map(x=> x.path)},
    editImageLogo(formData, index, fileList) {this.config.images.logo = fileList.map(x=> x.path)},
    beforeRemoveDash (index, done, fileList) {
        var r = confirm("¿Desea eliminar esta imagen?")
        if (r == true) {
            done()
            this.config.images.imgDash = fileList.map(x=> x.path)
        }
    },
    uploadImageSuccessDash(formData, index, fileList) {this.config.images.imgDash = fileList.map(x=> x.path)},
    editImageDash (formData, index, fileList) {this.config.images.imgDash = fileList.map(x=> x.path)},
    beforeRemoveIcon (index, done, fileList) {
        var r = confirm("¿Desea eliminar el icono?")
        if (r == true) {
            done()
            this.config.images.favIcon = fileList.map(x=> x.path)
        }
    },
    uploadImageSuccessIcon(formData, index, fileList) {this.config.images.favIcon = fileList.map(x=> x.path)},
    editImageIcon(formData, index, fileList) {this.config.images.favIcon = fileList.map(x=> x.path)},
    beforeRemoveAbout(index, done, fileList) {
        var r = confirm("¿Desea eliminar el logo?")
        if (r == true) {
            done()
            this.config.images.imgAbout = fileList.map(x=> x.path)
        }
    },
    uploadImageSuccessAbout(formData, index, fileList) {this.config.images.imgAbout = fileList.map(x=> x.path)},
    editImageAbout(formData, index, fileList) {this.config.images.imgAbout = fileList.map(x=> x.path)},
    tagOnMouseOver(){
        this.hover.tag.border = '2px solid ' + this.config.styles.colorAlert;
        this.hover.tag.background = this.config.styles.colorSecondary;
        this.hover.tag.text = "#FFFFFF";
    },
    tagOnMouseOut(){
        this.hover.tag.border='2px solid #eeeeee';
        this.hover.tag.background='#FFFFFF';
        this.hover.tag.text='#555555';
    },
    checkInputs(){
        if(this.config.show_mercadopago == true)
            if(this.config.mercadopago_app_token == undefined || this.config.mercadopago_app_token == null){
                alert('El token de mercado pago debe ser ingresado si quiere usar este medio de pago.');

                return false;
            }

        return true;
    }
  },

}
</script>
